/**
 * Directive: calendarCreateEvent
 */
angular.module('acme.common.directive.calendarCreateEvent', [
  'ui.router',
  'acme.common.service.validate',
  'acme.common.service.helpers',
  'acme.common.service.userPreferences'
])
.directive('calendarCreateEvent', ['$filter', function($filter) {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/calendar/createEvent/createEvent.tpl.html',
      scope: {
        calendarCreateEventId: '@calendarcreateeventid'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        $('body').append($element);

      },

      controller: ['$scope', '$element', '$document', 'ValidateService', 'HelpersService', 'UserPreferencesService', function($scope, $element, $document, ValidateService, HelpersService, UserPreferencesService) {

        $scope.calendarCreateEvent = {

          isEdit: false,
          isComplete: false,
          isSubmitted: false,
          isValidName: true,
          clicks: 0,
          displayStartTime: '',
          displayTitle: 'New Event',
          dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
          hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
          currentTarget: '',

          model: {
            id: '',
            name: '',
            startTime: '',
            endTime: ''
          },

          init: function() {
            $scope.$on('calendar::onDayClick', this.onDayClick);
            $scope.$on('calendar::onEventClick', this.onEventClick);
            console.log('calendarCreateEvent::init -> $document', $document);

            $document.on('click', this.onDocumentClick);
            $document.on('keydown', this.onDocumentKeydown);

            $scope.$on('$destroy', function(e) {
              $scope.calendarCreateEvent.cancel();
              $document.unbind('click');
              $document.unbind('keydown');
            });
          },

          validNameCheck: function() {
            var r = true;

            if (this.isSubmitted) {
              r = ValidateService.validate([
                { len: { value: this.model.name } }
              ]);
            }
            console.log('calendarCreateEvent::isValidName', r);
            this.isValidName  = r;
            return r;
          },

          complete: function() {

            this.isSubmitted = true;

            $element.removeClass('show');

            $scope.$emit('calendarCreateEvent::complete', {
              name: this.model.name,
              startTime: this.model.startTime,
              endTime: this.model.endTime
            });

          },

          edit: function() {
            // Event should be handled higher up the scope chain in calendar.js
            console.log('calendarCreateEvent::edit');
            $element.removeClass('show');
            $scope.$emit('calendarCreateEvent::edit', {
              model: this.model
            });
            this.isSubmitted = false;
            this.isComplete = false;
          },

          view: function() {
            // Event should be handled higher up the scope chain in calendar.js
            console.log('calendarCreateEvent::view');
            $element.removeClass('show');
            $scope.$emit('calendarCreateEvent::view', {
              model: this.model
            });
            this.isSubmitted = false;
            this.isComplete = false;
          },

          cancel: function() {
            // Event should be handled higher up the scope chain in calendar.js
            console.log('calendarCreateEvent::cancel');
            $element.removeClass('show');
            $scope.$emit('calendarCreateEvent::cancel');
            this.isSubmitted = false;
            this.isComplete = false;
            this.clicks = 0;

            if (this.currentTarget) {
              angular.element(this.currentTarget).focus();
              this.currentTarget = '';
            }
          },

          done: function() {
            if (this.isEdit) {
              this.view();
            }else{
              this.complete();
            }
          },
          getRequestsForCategory: function(event, category) {
            var categorySuffix,
                fulfilled = 0,
                total = 0,
                limit = 3,
                requests,
                r = '';

            if (category === 'place') {
              categorySuffix = 'Places';
            }else {
              categorySuffix = HelpersService.cap(category);
            }

            if (event.requestSummary && event.requestSummary.hasOwnProperty(category)) {
              fulfilled = event.requestSummary[category].fulfilledRequestsCount ? event.requestSummary[category].fulfilledRequestsCount : 0;
              total = event.requestSummary[category].totalRequestsCount ? (event.requestSummary[category].totalRequestsCount) : 0;
              requests = (total) ?  (fulfilled + '/' + total) : '';
              // Show resource name if total and fulfilled is 1 and only 1
              if (fulfilled > 0) {
                if (event.requestSummary[category].resourceNames instanceof Array &&
                  event.requestSummary[category].resourceNames[0]) {
                  if (total === fulfilled) {
                    if (fulfilled > 3) {
                      r = event.requestSummary[category].resourceNames.slice(0, limit).join(', ') + ', +' + (fulfilled - limit) + ' more';
                    }else{
                      r = event.requestSummary[category].resourceNames.join(', ');
                    }
                  }else if (fulfilled < total) {
                    if (fulfilled > 3) {
                      r = event.requestSummary[category].resourceNames.slice(0, limit).join(', ') + ', +' + (fulfilled - limit) + ' more';
                    }else{
                      r = event.requestSummary[category].resourceNames.join(',');
                    }
                    r +=  ', ' + (total - fulfilled) + ' unassigned';
                  }

                  r = categorySuffix + ': ' + r;
                }
              }else {
                r = requests ? requests + ' ' + categorySuffix : '';
              }
            }

            return r;

          },

          onDocumentClick: function(e, data) {
            var target = $(e.target),
                id = 'calendar-create-event-' + $scope.calendarCreateEventId;

            $scope.calendarCreateEvent.clicks++;
            console.log('calendarCreateEvent::onDocumentClick -> e', e);
            console.log('calendarCreateEvent::onDocumentClick -> target', id, target.attr('id'));
            console.log('calendarCreateEvent::onDocumentClick -> clicks', $scope.calendarCreateEvent.clicks);

            if ((target.attr('id') !== id &&
                target.parents('#'+id).length === 0) &&
                $scope.calendarCreateEvent.clicks > 1) {
              $scope.calendarCreateEvent.cancel();
            }

            if (e.target.innerHTML.toLowerCase() ==='today') {
              $scope.$emit('calendarCreateEvent::todayClick');
            }
          },

          onDocumentKeydown: function(e, data) {
            if (e.keyCode === 27) {
              $scope.calendarCreateEvent.clicks = 0;
              $scope.calendarCreateEvent.cancel();
            }
          },

          onEventClick: function(e, data) {

            var el,
                pos,
                top,
                left,
                endTime,
                startTime,
                self = $scope.calendarCreateEvent,
                vWidth = $(window).width(),
                sTop = $(window).scrollTop(),
                elWidth = parseInt($element.width(), 10);

            el = $(data.event.target);
            pos = el.offset();

            startTime = new Date(data.calEvent.start.getFullYear(), data.calEvent.start.getMonth(), data.calEvent.start.getDate(), data.calEvent.start.getHours(), data.calEvent.start.getMinutes());
            if (data.calEvent.end) {
              endTime = new Date(data.calEvent.end.getFullYear(), data.calEvent.end.getMonth(), data.calEvent.end.getDate(), data.calEvent.end.getHours(), data.calEvent.end.getMinutes());
            }else{
              endTime = new Date(data.calEvent.start.getFullYear(), data.calEvent.start.getMonth(), data.calEvent.start.getDate(), data.calEvent.start.getHours(), data.calEvent.start.getMinutes());
            }

            self.displayStartTime = $filter('date')(startTime, self.dateFormat);
            self.displayEventTime = $filter('date')(startTime, self.hourFormat) + ' - ' + $filter('date')(endTime, self.hourFormat);
            self.displayTitle = data.calEvent.title || 'New Event';
            self.displayEventName = data.calEvent.eventName || 'New Event';
            self.displayScheduleName = data.calEvent.scheduleName;
            self.displayPeople = self.getRequestsForCategory(data.calEvent, 'people');
            self.displayPlaces = self.getRequestsForCategory(data.calEvent, 'place');
            self.displayEquipment = self.getRequestsForCategory(data.calEvent, 'equipment');
            self.isSubmitted = false;
            self.isEdit = (data.calEvent.title);
            self.isComplete = false;
            self.clicks = 0;
            self.isValidName = true;
            self.model.name = data.calEvent.title;
            self.model.id = data.calEvent.id;
            self.model.startTime = startTime;
            self.model.endTime = endTime;
            self.currentTarget = '#fc-event-id-' + data.calEvent.id;
            
            top = (pos.top - parseInt($element.height(), 10) - 30) + 'px';
            left = pos.left;

            if (parseInt(top, 10) < sTop) {
              top = (el.offset().top + 50) + 'px';
            }

            if (left + elWidth > vWidth) {
              left = vWidth - elWidth;
            }

            $element.css({
              top: top,
              left: left
            }).addClass('show');
            
            self.setFocusElements();
          },
          
          setFocusElements: function () {
            var inputs = $element.find('a, select, input, textarea, button'),
                firstInput = inputs.first(),
                lastInput = inputs.last();
                
            firstInput.focus();
            /*redirect first shift+tab to last input*/
            firstInput.on('keydown', function (e) {
                if ((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastInput.focus();
                }
            });
            /*redirect last tab to first input*/
            lastInput.on('keydown', function (e) {
               if ((e.which === 9 && !e.shiftKey)) {
                   e.preventDefault();
                   firstInput.focus();
               }
            });
          },

          onDayClick: function(e, data) {
            var el,
                pos,
                top,
                left,
                endTime,
                startTime,
                self = $scope.calendarCreateEvent,
                vWidth = $(window).width(),
                sTop = $(window).scrollTop(),
                elWidth = parseInt($element.width(), 10);

            console.log('calendarCreateEvent::onDayClick', data);
            
            el = $(data.view.currentTarget);
            pos = el.offset();

            startTime = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate(), 12, 0);
            endTime = new Date(data.date.getFullYear(), data.date.getMonth(), data.date.getDate(), 13, 30);

            self.displayStartTime = $filter('date')(startTime, self.dateFormat);
            self.displayEventTime = $filter('date')(startTime, self.hourFormat) + ' - ' + $filter('date')(endTime, self.hourFormat);
            self.displayTitle = 'New Event';
            self.displayEventName = 'New Event';
            self.displayScheduleName = '';
            self.displayPeople = '';
            self.displayPlaces = '';
            self.displayEquipment = '';
            self.isSubmitted = false;
            self.isComplete = false;
            self.isEdit = false;
            self.clicks = 0;
            self.isValidName = true;
            self.model.name = '';
            self.model.id = '';
            self.model.startTime = startTime;
            self.model.endTime = endTime;
            self.currentTarget = data.view.currentTarget;

            $scope.$apply();

            top = (pos.top - parseInt($element.height(), 10)) + 'px';
            left = pos.left;

            if (parseInt(top, 10) < sTop) {
              top = (el.offset().top + 140) + 'px';
            }

            if (left + elWidth > vWidth) {
              left = vWidth - elWidth;
            }

            $element.css({
              top: top,
              left: left
            }).addClass('show');

            angular.element('#input-calendar-create-event-name').focus();

          }

        };

        $scope.calendarCreateEvent.init();

      }]

    };

}]);